// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_alignRight_JAmXP5tPvBd3sXk2CDZR {
  display: block;
  width: 100%;
  text-align: right;
}

.style-module_percentageContainer_CLb_LLGrC58URdOJjDVw {
  width: 100%;
}

.style-module_percentageWrapper_E7Ct_QeLdvivRJWX3Smh {
  height: 8px;
  background-color: #efefef;
  border-radius: 4px;
  margin-bottom: 0.2rem;
  overflow: hidden;
}

.style-module_percentageValue__bnSkpbvFXFhGB12djX1 {
  height: 8px;
  border-radius: 4px;
}

.style-module_percentageText_cybj62mEJeoO8Qk5zHjW {
  font-size: 0.8rem;
}

.style-module_byUserValue_Evq7p6eaOamucIp3m9MM {
  font-weight: 400;
  font-size: 14px;
  color: var(--text-02);
}

.style-module_dateValue_WgJa2AZVAOf6Pp9c3Po4 {
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  color: #000;
  margin-bottom: 3px;
}`, "",{"version":3,"sources":["webpack://./src/utils/style.module.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAEA;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,kBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AACF","sourcesContent":[".alignRight {\n  display: block;\n  width: 100%;\n  text-align: right;\n}\n\n.percentageContainer {\n  width: 100%;\n}\n\n.percentageWrapper {\n  height: 8px;\n  background-color: #efefef;\n  border-radius: 4px;\n  margin-bottom: 0.2rem;\n  overflow: hidden;\n}\n\n.percentageValue {\n  height: 8px;\n  border-radius: 4px;\n}\n\n.percentageText {\n  font-size: 0.8rem;\n}\n\n.byUserValue {\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--text-02);\n}\n\n.dateValue {\n  font-style: italic;\n  font-weight: 400;\n  font-size: 14px;\n  color: #000;\n  margin-bottom: 3px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alignRight": `style-module_alignRight_JAmXP5tPvBd3sXk2CDZR`,
	"percentageContainer": `style-module_percentageContainer_CLb_LLGrC58URdOJjDVw`,
	"percentageWrapper": `style-module_percentageWrapper_E7Ct_QeLdvivRJWX3Smh`,
	"percentageValue": `style-module_percentageValue__bnSkpbvFXFhGB12djX1`,
	"percentageText": `style-module_percentageText_cybj62mEJeoO8Qk5zHjW`,
	"byUserValue": `style-module_byUserValue_Evq7p6eaOamucIp3m9MM`,
	"dateValue": `style-module_dateValue_WgJa2AZVAOf6Pp9c3Po4`
};
export default ___CSS_LOADER_EXPORT___;
